
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/joc-aeri",
      function () {
        return require("private-next-pages/3catinfo/joc-aeri/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/joc-aeri"])
      });
    }
  